import { jsonldCurrencyValue } from './JsonldStore';

export const updateJsonldCurrencyValue = (value) => jsonldCurrencyValue.update((oldValue) => value);
